<div class="content-loader">
    <div class="content-line"></div>
    <div class="content-line short"></div>
    <div class="content-line"></div>
    <div class="content-circle"></div>
  </div>